import React from 'react';
import { MapPin, TrendingUp } from 'lucide-react';

const LeadTimeCard = ({ data, country }) => {
    if (!data) return null;

    return (
        <div className="w-full bg-gradient-to-br from-blue-50 via-white to-purple-50 rounded-xl border border-blue-100 shadow-sm overflow-hidden">
            {/* Main Container */}
            <div className="flex items-center justify-between px-6 py-4 gap-6">

                {/* Left Side: Days Display */}
                <div className="flex items-center gap-6 flex-1">
                    {/* Days Content */}
                    <div className="flex flex-col gap-1">
                        {/* Days Numbers */}
                        <div className="flex items-center gap-2">
                            <span className="text-4xl font-bold text-gray-900 leading-none">{data.fromDays}</span>
                            <span className="text-2xl font-light text-gray-400 leading-none">—</span>
                            <span className="text-4xl font-bold text-gray-900 leading-none">{data.toDays}</span>
                            <span className="text-lg font-semibold text-gray-500 ml-1">Days</span>
                        </div>

                        {/* Description */}
                        <div className="flex items-center gap-1.5 text-gray-500">
                            <TrendingUp size={13} className="text-blue-500" />
                            <p className="text-xs font-medium">Estimated delivery time</p>
                        </div>
                    </div>
                </div>

                {/* Right Side: Destination Tag with Enhanced Design */}
                <div className="flex-shrink-0">
                    <div className="flex items-center gap-3 bg-white px-5 py-3 rounded-full border-2 border-blue-200 shadow-sm hover:shadow-md transition-shadow">
                        <div className="w-9 h-9 rounded-full bg-blue-100 flex items-center justify-center">
                            <MapPin size={18} className="text-blue-600" strokeWidth={2} />
                        </div>
                        <div className="flex items-center gap-2">
                            <span className="text-sm font-medium text-gray-500 uppercase tracking-wide">Destination:</span>
                            <span className="text-base font-bold text-gray-900">{country}</span>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default LeadTimeCard;